module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kBAZw"))).then(() => parcelRequire('hEqeo'));